// Naming the codec lets a browser without VP9 reject the source up front
// instead of loading its metadata and stalling without an error.
export const HERO_VIDEO_TYPE = 'video/webm; codecs="vp9"'

// With every <source> failed, play() stays pending instead of rejecting.
export function hasNoPlayableSource(video: HTMLVideoElement) {
  return !!video.error || video.networkState === video.NETWORK_NO_SOURCE
}

function isPlaybackRefusal(error: unknown) {
  return (
    error instanceof DOMException &&
    (error.name === "NotAllowedError" || error.name === "NotSupportedError")
  )
}

// Every play path routes a refusal here, so the poster stands in wherever
// playback is denied rather than only on the paths that remembered to check.
export function playOrReportRefusal(
  video: HTMLVideoElement | null,
  onRefusal: () => void
) {
  void video?.play().catch((error: unknown) => {
    if (isPlaybackRefusal(error)) onRefusal()
  })
}
